import { v4 } from 'uuid';

const ACTOR_LABELS: Record<string, string> = {
  A: 'APP',
  S: 'Schedule',
  M: 'Manual',
};

// Events whose data is appended to the type so it shows in the events list
const DATA_EVENT_TYPES = ['awake', 'enterStandby', 'battery', 'rebooted'];

const toDisplayEvent = (event: any, type: string): MoveEvent => ({
  account: '',
  created:
    event.created !== undefined ? event.created : new Date().toISOString(),
  id: v4(),
  media_key_1: '',
  name: '',
  parent: '',
  type,
  updated:
    event.updated !== undefined ? event.updated : new Date().toISOString(),
});

// Formats a move event for the events list, adding the source and changed
// values for configChange events
export const formatMoveEvent = (event: any): MoveEvent => {
  if (event.type === 'configChange') {
    const { actor, ...items } = event.data || {};
    const source = ACTOR_LABELS[actor] || '';
    return toDisplayEvent(
      event,
      `configChange - ${source} : ${JSON.stringify(items)}`,
    );
  }
  if (DATA_EVENT_TYPES.includes(event.type)) {
    return toDisplayEvent(
      event,
      `${event.type} - ${JSON.stringify(event.data)}`,
    );
  }
  return event;
};

// Returns the config values changed by a configChange event, or undefined for
// any other event.
export const getConfigChanges = (
  event: any,
): Record<string, any> | undefined => {
  if (event.type !== 'configChange' || !event.data) {
    return undefined;
  }
  const { actor, ...changes } = event.data;
  return changes;
};

const isObject = (value: any) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

// Merges config changes into a config. Values under `channel-<n>` are merged
// into that channel's nested config instead of replacing it.
export const mergeConfigChanges = <T extends Record<string, any>>(
  config: T,
  changes: Record<string, any>,
): T => {
  const next: Record<string, any> = { ...config };
  Object.keys(changes).forEach((key) => {
    if (
      key.startsWith('channel-') &&
      isObject(next[key]) &&
      isObject(changes[key])
    ) {
      next[key] = { ...next[key], ...changes[key] };
    } else {
      next[key] = changes[key];
    }
  });
  return next as T;
};
